import React from 'react';
import { useDarkMode } from '../../context/DarkModeContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { PieChartIcon, MapIcon, TrendingUpIcon, MessageSquareIcon } from 'lucide-react';
import BackButton from '../../components/UI/BackButton';
const ReaderInsights = () => {
  const {
    darkMode
  } = useDarkMode();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  return <div className={`min-h-screen py-8 ${dk.page}`} data-id="element-22224" data-mp="24ox40wnfye3u">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22225" data-mp="1zvkdggz7bx8g">
        <div className="mb-4" data-id="element-22226" data-mp="1vuimenffurhk">
          <BackButton data-id="element-22227" data-mp="1vvtomit8jr6k" />
        </div>
        <h1 className={`text-3xl font-bold mb-8 ${dk.textHeading}`} data-id="element-22228" data-mp="1vso47gvjxdh6">
          Reader Insights
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-22229" data-mp="1qtunlfkyx6cs">
          <div className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-22230" data-mp="1lw2tcewup85f">
            <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textPrimary}`} data-id="element-22231" data-mp="1gyj6iqm37n1v">
              <PieChartIcon className={`h-5 w-5 mr-2 ${rt.textPrimary}`} data-id="element-22232" data-mp="1rxr400wuj6lq" />
              Reader Demographics
            </h2>
            <div className={`h-64 rounded-lg flex items-center justify-center ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`} data-id="element-22233" data-mp="1ws4zs4ff7fqx">
              <p className={dk.textMuted} data-id="element-22234" data-mp="1n1agn8xh0w9p">Age & Gender Distribution Chart</p>
            </div>
          </div>

          <div className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-22235" data-mp="2ar4rxm256cru">
            <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textPrimary}`} data-id="element-22236" data-mp="2fpfy9mt8a55b">
              <MapIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-22237" data-mp="20qm1u9jzi01h" />
              Geographic Distribution
            </h2>
            <div className={`h-64 rounded-lg flex items-center justify-center ${darkMode ? 'bg-gray-700' : 'bg-gray-100'}`} data-id="element-22238" data-mp="25p5ne8uo19tb">
              <p className={dk.textMuted} data-id="element-22239" data-mp="uc361bkqsg83">World Map Visualization</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-22240" data-mp="2wyiansnt9an0">
          <div className={`lg:col-span-2 p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-22241" data-mp="2rz5nf6t121jw">
            <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textPrimary}`} data-id="element-22242" data-mp="2n85tmaf7fzlm">
              <TrendingUpIcon className="h-5 w-5 mr-2 text-green-600" data-id="element-22243" data-mp="2ia4a5odv9y9m" />
              Reading Behavior
            </h2>
            <div className="space-y-4" data-id="element-22244" data-mp="2db14c1q2bo0l">
              {[{
              label: 'Completion Rate',
              value: '78%',
              width: '78%',
              color: 'bg-green-500'
            }, {
              label: 'Average Read Time',
              value: '6h 45m',
              width: '65%',
              color: 'bg-blue-500'
            }].map(({
              label,
              value,
              width,
              color
            }) => <div key={label} data-id="element-22245" data-mp="3tpj2gev4s1ye">
                  <div className="flex justify-between text-sm mb-1" data-id="element-22246" data-mp="3tmes0zr2o9za">
                    <span className={dk.textSecondary} data-id="element-22247" data-mp="51uy1pb23qxz">{label}</span>
                    <span className={`font-bold ${dk.textPrimary}`} data-id="element-22248" data-mp="a17glxuwabur">
                      {value}
                    </span>
                  </div>
                  <div className={`w-full rounded-full h-2 ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`} data-id="element-22249" data-mp="et7n695h030b">
                    <div className={`${color} h-2 rounded-full`} style={{
                  width
                }} data-id="element-22250" data-mp="3i9o7vdqycx2n" />
                  </div>
                </div>)}
            </div>
          </div>

          <div className={`p-6 rounded-xl shadow-sm border ${dk.card}`} data-id="element-22251" data-mp="10riz50u1yxt">
            <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textPrimary}`} data-id="element-22252" data-mp="yycbpq7zept">
              <MessageSquareIcon className="h-5 w-5 mr-2 text-orange-600" data-id="element-22253" data-mp="1cg6cfytu28o6" />
              Review Sentiment
            </h2>
            <div className="flex items-center justify-center h-40" data-id="element-22254" data-mp="1a0rhtx76vssj">
              <div className="text-center" data-id="element-22255" data-mp="15zxtx3tqydzn">
                <p className={`text-4xl font-bold ${rt.textPrimary}`} data-id="element-22256" data-mp="160zhg7ry8sy9">4.8/5</p>
                <p className={`text-sm mt-1 ${dk.textMuted}`} data-id="element-22257" data-mp="1k08niemfy6oi">
                  Average Sentiment Score
                </p>
              </div>
            </div>
            <div className="space-y-2 text-sm" data-id="element-22258" data-mp="1f2p5r4qjbbrt">
              <div className="flex justify-between" data-id="element-22259" data-mp="1szm0hh9rxddz">
                <span className={dk.textSecondary} data-id="element-22260" data-mp="1sy13lkzzlicy">Positive</span>
                <span className="text-green-500" data-id="element-22261" data-mp="1oyagpsdkzmdp">92%</span>
              </div>
              <div className="flex justify-between" data-id="element-22262" data-mp="22p5gmf63qt55">
                <span className={dk.textSecondary} data-id="element-22263" data-mp="22s1ds1a4ldsj">Neutral</span>
                <span className={dk.textMuted} data-id="element-22264" data-mp="1xrnhthlstuav">5%</span>
              </div>
              <div className="flex justify-between" data-id="element-22265" data-mp="2cnlbmt892mjx">
                <span className={dk.textSecondary} data-id="element-22266" data-mp="2cm0d6sitejgs">Negative</span>
                <span className="text-red-500" data-id="element-22267" data-mp="27ql56h7hnhsa">3%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ReaderInsights;